export default "__VITE_ASSET__DKJTj8y0__"